const size = {
  mobile: '320px',
  mobileM: '375px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1440px',
}

export const device = {
  mobile: `(min-width: ${size.mobile})`,
  mobileM: `(min-width: ${size.mobileM})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  desktop: `(min-width: ${size.desktop})`,
}
